import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsHeaderVisible(false);
      } else {
        setIsHeaderVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <header className={`header ${isHeaderVisible ? 'visible' : 'hidden'}`}>
      <div className="header-container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span className="logo-text">croqly</span>
          </Link>
          <nav className="navigation">
            <Link to="/" className="nav-item">Home</Link>
            <Link to="/terms" className="nav-item">Terms</Link>
            <Link to="/privacy" className="nav-item">Privacy</Link>
            <Link to="/contact" className="nav-item">Contact</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
